jQuery(function ($) {
  "use strict";

  var init = [
    function () {
      if ($('.scroll-to-top').length) {
        let mybutton = document.getElementById("btn-back-to-top");

        // When the user scrolls down 150px from the top of the document, show the button
        window.onscroll = function () {
          scrollFunction();
        };

        function scrollFunction() {
          if (
            document.body.scrollTop > 150 ||
            document.documentElement.scrollTop > 150
          ) {
            mybutton.style.display = "block";
          } else {
            mybutton.style.display = "none";
          }
        }
        // When the user clicks on the button, scroll to the top of the document
        mybutton.addEventListener("click", backToTop);

        function backToTop() {
          document.body.scrollTop = 0;
          document.documentElement.scrollTop = 0;
        }
      } else {}
    },
    function () {
      if ($('.main-navigation .main-navigation__search .site-search').length) {
        $(".main-navigation .main-navigation__search .site-search").click(function(){
          $(".main-navigation .main-navigation__search .search-form").toggle();
        });
      }
    },
    function () {
      $(document).ready(function() {
        var modalInner = $('.modal__inner');
        modalInner.each(function() {
          var content = $(this);
          $(this).remove();
          $('.entry-content').append(content);
        });
      });
    },
      function () {
      new WOW(
        {
          boxClass:     'wp-block-column',
          animateClass: 'fadeIn',
          offset:       0,
          mobile:       false,
          live:         true,
        }
      ).init();
    },
    function () {
      new WOW(
        {
          boxClass:     'wp-block-cover__inner-container',
          animateClass: 'fadeInUp',
          offset:       0,
          mobile:       false,
          live:         true,
        },
      ).init();
    },
    function () {
      $('s').addClass('strikethrough');
    },
    function () {
      new WOW(
        {
          boxClass:     'strikethrough',
          animateClass: 'increase',
          offset:       50,
          mobile:       true,
          live:         true,
        }
      ).init();
    },
    function () {
      $(window).on('load', function menuStuff() {
        var headerHeight = $('.site-header').outerHeight();
        var body = $('body');
        var sticky = $('.site-header');
        let menu = $('#menu');
        let nav = $('.main-navigation__nav');

        // Function to handle sticky header
        function handleStickyHeader() {
          var scroll = $(window).scrollTop();

          if (scroll >= headerHeight + 10) {
            sticky.addClass('site-header--sticky');
            body.css('padding-top', headerHeight);
          } else {
            sticky.removeClass('site-header--sticky');
            body.css('padding-top', 0);
          }
        }

        // Initial call to handleStickyHeader to set the initial state
        handleStickyHeader();

        // Bind scroll event to handleStickyHeader
        $(window).scroll(handleStickyHeader);

        // Set initial top position for mobile navigation
        $('.site-header .main-navigation .main-navigation__nav').css('top', headerHeight);

        menu.on('click', function(e) {
          $(this).toggleClass('is-open');
          nav.toggleClass('is-open');
        });
      }).init();
    },
    function () {
      // Get the current time
      var currentTime = new Date();
      var hours = currentTime.getHours();

      // Time ranges
      var nightStart = 19; // hours
      var morningStart = 5;
      var afternoonStart = 12;

      // Find the time of the day and update the class
      if (hours >= nightStart || hours < morningStart) {
        // Night
        $('.site-footer__bianchi-artwork .bianchi-artwork').addClass('night').removeClass('morning afternoon');
      } else if (hours >= morningStart && hours < afternoonStart) {
        // Morning
        $('.site-footer__bianchi-artwork .bianchi-artwork').addClass('morning').removeClass('night afternoon');
      } else {
        // Afternoon
        $('.site-footer__bianchi-artwork .bianchi-artwork').addClass('afternoon').removeClass('night morning');
      }    
    },
    function () {
      gsap.from(".bianchi-artwork__landscape", {
        scrollTrigger: {
          scrub: true,
        },
        y: -75,
      });
      gsap.from(".bianchi-artwork__moon", {
        scrollTrigger: {
          scrub: true,
        },
        y: 75,
      });
      gsap.from(".afternoon .bianchi-artwork__sun", {
        scrollTrigger: {
          scrub: true,
        },
        y: 75,
      });
      gsap.from(".morning .bianchi-artwork__sun", {
        scrollTrigger: {
          scrub: true,
        },
        y: 200,
      });
      gsap.from(".bianchi-artwork__light", {
        scrollTrigger: {
          scrub: true,
        },
        y: 150,
      });
    },
  ];

  $.each(init, function (index, initFunction) {
    initFunction();
  });
});